import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { startOfMonth, endOfMonth, setMonth } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Facility } from '../../../interfaces/facility';
import { Records } from '../../../interfaces/records';
import { Stores } from '../../../interfaces/stores';
import { RoundsRecords } from '../../../interfaces/rounds_records';
import { RoundsConfiguration } from '../../../interfaces/rounds_configuration';
import { RoundsType } from '../../../interfaces/rounds_type';

@Component({
  selector: 'app-list-rounds-facility',
  templateUrl: './list-rounds-facility.component.html',
  styleUrls: ['./list-rounds-facility.component.css']
})
export class ListRoundsFacilityComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal,
    private dateAdapter: DateAdapter<Date>

  ) { }

  loading: boolean = false;
  pathDownload: string = null;


  @Input()
  facilityId:number;

  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  ngOnInit(): void {
    this.dateAdapter.setLocale('es'); // Establece el idioma de las fechas a español
    this.mesActual = new Date();
    if(this.facilityId>0){
      this.getData();
      this.get(); 
    }
   
  }

  items: RoundsConfiguration[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  facilityes:Facility[];
  stores:Stores[];
  types: RoundsType[];

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    start: new UntypedFormControl(),
    end: new UntypedFormControl(),
    active:new UntypedFormControl(0),
    rounds_type_id: new UntypedFormControl(0),
    facility_id:new  UntypedFormControl(0),
    stores_id: new UntypedFormControl(0),
    order: new UntypedFormControl(2),
    orderType: new UntypedFormControl(1),
  });

  setDaysStartEnd() {
      this.inicioMes = startOfMonth(this.mesActual);
      this.finMes = endOfMonth(this.mesActual);
    this.form.controls['start'].setValue(this.inicioMes.toISOString().substring(0, 10));
    this.form.controls['end'].setValue(this.finMes.toISOString().substring(0, 10));
    this.get();
  }
  get() {
    this.form.get('facility_id')?.setValue(this.facilityId);
    this.page=1;
    this.api.paginateRecordsFacility(this.page,  this.form,2).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as RoundsConfiguration[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = [];
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
      }
    );
  }


  search() {
    this.get();
  }


  mesView: string;
  mesActual: Date;
  fechas: Date[];
  //dia inicial del mes
  inicioMes: Date;

  //dia final del mes
  finMes: Date;
  setStartDay(event: any) {
    this.form.get('start')?.setValue(event.value);
  }

  cambiarMes(delta: number): void {
    this.mesActual = setMonth(this.mesActual, this.mesActual.getMonth() + delta);
    this.mesView = this.mesActual.toISOString();
    this.setDaysStartEnd();
  
  }

  obtenerNombreMes(mes: number): string {
    const nombresMeses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    return nombresMeses[mes];
  }
  openModal(mdl: any) {
    this.modal.open(mdl);
  }
  getData() {
    this.api.getAllRoundsType().subscribe(
      (response) => {
        this.types = response.data as RoundsType[];
      }
    );
    this.api.getAllStores().subscribe(
      (response) => {
        this.stores = response.data as Stores[];
      }
    );
  }

  generateReport(mdl: any) {
    this.modal.open(mdl);
    // Simular un proceso de generación de reporte
    this.loading = true;
    this.api.generateReport(this.form, 2).subscribe(
      (rs) => {
        console.log("REPORT SUCCESS:", rs);
        this.loading = false;
        this.toast.success(rs.msg);
        let result = rs as any;
        this.pathDownload = result?.path;
      },
      e => {
        console.log("REPORT ERROR:", e);
        this.loading = false;
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }
  setOrder() {
    let valueNow=(this.form.get('order')?.value==1)?2:1;
    this.form.get('order')?.setValue(valueNow);
  }
}

